module.exports = __webpack_public_path__ + "static/solos_e_plantas_logo-424a2db79195325017de816aa45719c3.png";